import { useContext } from 'react'

import { NewConversationContext } from './new-conversation-context'

/** convenience hook for the new-conversation form fields. throws when
 * used outside NewConversationFormProvider . matches the signup hook.
 */
export function useNewConversation() {
  const ctx = useContext(NewConversationContext)
  if (!ctx) {
    throw new Error(
      'useNewConversation must be used within NewConversationFormProvider'
    )
  }
  return ctx
}
